import React, { type ComponentProps } from 'react';
import { BaseIcon } from '@is24at/react-ui-core/Icons';

export const OVILogo = (props: ComponentProps<typeof BaseIcon>) => (
  <BaseIcon {...props} viewBox="0 0 276 157">
    <g fill="#676767" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M221.672 36.904L258.25.424l16.614 16.58-36.58 36.48zM40.46 36.904L77.04.424l16.613 16.58-36.579 36.48z"
      />
      <path d="M107 37h36.835l22.44 72.8L188.679 37H215l-40.646 120H147.61zM255 42v115h-33V43.207s16.069 16.469 15.897 16.398L255 42z" />
      <path
        d="M35.849 37l18.28 17.995c-12.601 3.868-15.192 16.149-16.15 25.59-.452 4.611-.641 9.244-.569 13.877 0 11.251-.425 39.042 19.806 39.042h.568c20.231 0 19.806-27.826 19.806-39.042.072-4.633-.117-9.266-.568-13.877-.959-9.441-3.55-21.722-16.15-25.59L79.152 37C107.936 48.038 115 73.7 115 95.598c0 31.73-17.25 58.492-51.679 61.189-1.74 0-3.55.213-5.821.213-2.272 0-3.94 0-5.821-.213C17.25 154.09 0 127.328 0 95.598 0 73.699 7.099 48.038 35.849 37"
        fillRule="nonzero"
      />
    </g>
  </BaseIcon>
);
